import { Component } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
@Component({
  selector: "app-fortune-missions-popup",
  templateUrl: "./fortune-missions-popup.component.html",
  styleUrls: ["./fortune-missions-popup.component.scss"],
  standalone: true,
  imports: [IonicModule],
})
export class FortuneMissionsPopupComponent {
  public userId: string;
  constructor(public dialogRef: MatDialogRef<FortuneMissionsPopupComponent>, private analytics: AngularFireAnalytics, private authService: AuthService) {
  }
  async ngOnInit() {
    await this.authService
      ?.getUid("FortuneMissionsPopupComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("syndicate_member_modal", { userId: this.userId });
      })
      .catch((error) => {
        return error;
      });
  }

  close() {
    this.dialogRef.close();
  }
}
